import { capitalize } from 'lodash';
import React from 'react';
import { Col, FormGroup, HelpBlock, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { getOrgTermsContent } from '../../../../content/utils.js';
import { PROJECT_ROLES, PROJECT_ROLES_DESC } from '../../../../lib/schema.js';
import CheckboxAdapter from '../../../CheckboxAdapter.jsx';

const roleOptions = PROJECT_ROLES.map((role, index) => ({
  label: capitalize(role),
  value: role,
  desc: PROJECT_ROLES_DESC[index],
}));

const ProjectRole = ({ errors, submitFailed }) => {
  return (
    <Row className="m-b-60">
      <Col xs={12} className="m-b-24">
        <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
          <h3>Select Role</h3>
        </div>

        <p className="communication-help text-muted">
          {getOrgTermsContent('projectRoleSubtitle')}
        </p>
      </Col>

      <Col xs={9}>
        {roleOptions.map((role, index) => (
          <div className="m-b-24" key={`projectRole${role.value}`}>
            <Field
              className="m-0"
              label={role.label}
              name="roles"
              value={role.value}
              type="checkbox"
              component={CheckboxAdapter}
            />
            <p className="text-muted m-l-32 m-b-0">{role.desc}</p>
          </div>
        ))}
      </Col>
      <Col xs={12}>
        {submitFailed && (
          <FormGroup validationState="error">
            <HelpBlock>{errors.roles}</HelpBlock>
          </FormGroup>
        )}
      </Col>
    </Row>
  );
};

export default ProjectRole;
